/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/button-has-type */
import React, { useState, useRef } from 'react';
import {
  useNotifications,
  NOTIFICATION_STATUSES,
} from '@adsk/alloy-react-notification';
import { useLocale } from '@adsk/alloy-react-locale';
import { useCurrentProjectId, useCurrentProductId } from '@adsk/alloy-provider';
import InviteTrialMemberModal from '@adsk/acs-admin-ui-components-invite-trial-member-modal';
import { buildProductMemberUrl } from './utils';
import { STATUS } from './constants';

const InviteTrialMemberWrappedModal = () => {
  const [open, setOpen] = useState(false);
  const productId = useCurrentProductId();
  const projectId = useCurrentProjectId();
  const inputRef = useRef();
  const { showNotification } = useNotifications();
  const { T } = useLocale(({ locale }) => require(`./i18n/${locale}.json`));

  const handleSubmit = ({ emails, status }) => {
    if (status === STATUS.ERROR) {
      showNotification({
        status: NOTIFICATION_STATUSES.ERROR,
        message:
          emails.length > 1
            ? T.translate('INVITE_TRIAL_ERROR_MEMBERS')
            : T.translate('INVITE_TRIAL_ERROR_MEMBER', {
                email: emails[0].label,
              }),
      });
    }
    if (status === STATUS.SUCCESS) {
      setOpen(false);
      window.location.assign(buildProductMemberUrl(projectId, productId));
    }
  };

  const handleClick = () => {
    setOpen(true);
  };

  const onClose = () => {
    setOpen(false);
  };

  return (
    <>
      <button
        id="invite-trial-member-button"
        hidden
        ref={inputRef}
        onClick={handleClick}
      />
      <InviteTrialMemberModal
        show={open}
        onSubmit={handleSubmit}
        onClose={onClose}
      />
    </>
  );
};

export default InviteTrialMemberWrappedModal;
